<% var component = new Anvil.models.components.Map(name, list, search_fields, params) %>
<div anvil-component="<%- component.id %>" id="<%- component.name %>_map">
	<div class="row">
		<div class="col pe-0">
			<div class="grid-wrapper" style="position:relative; overflow-y:auto; height:calc(100vh - 155px);">
				<div id="<%- component.name %>_map_frame" style="position:relative; width:100%; height:100%; z-index:0;"></div>
			</div>
		</div>
		<div class="col-auto px-0">
			<div id="<%- component.name %>_map_overlay" class="d-none" style="z-index:0; height:calc(100vh - 155px); margin:1px -6px 0 6px; border:1px solid var(--bs-border-color); border-radius:0.25rem; width:454px; overflow-y:auto;"></div>
		</div>
		<div class="col-auto" style="width:274px;">
			<div id="<%- component.name %>_map_list" class="grid-wrapper" style="overflow-y:auto; height:calc(100vh - 155px);"></div>
		</div>
	</div>
</div>
